import { CheckIcon } from "@heroicons/react/24/solid";

function CheckList(props) {
  return (
    <div className="lg:tw-flex lg:tw-space-x-5">
      {props.title && (
        <div className="tw-block tw-p-4 md:tw-p-8 tw-rounded-xl tw-bg-gray-light tw-font-condensed tw-font-black tw-text-xl md:tw-text-4xl tw-uppercase tw-italic lg:tw-whitespace-pre-line tw-pr-16">
          {props.title}
        </div>
      )}
      <ul className="tw-px-5 tw-py-5 tw-pt-0 lg:tw-pt-5 lg:tw-p-8 lg:tw-rounded-xl tw-bg-gray-light lg:tw-flex-1 lg:tw-columns-2 lg:tw-gap-5">
        {props.items.map((item, index) => {
          let margin = (index == 0) ? 'tw-mt-0':'';
          return (
            <li
              className={"tw-flex tw-items-center tw-my-2 "+margin}
              key={"check-list_" + index}
            >
              <CheckIcon className="tw-text-teal tw-w-6 tw-h-6 tw-flex-none tw-self-start" />
              <span className="tw-ml-2 tw-flex-auto">{item}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default CheckList;
